(function() {
  "use strict";

  angular.module("PrintixInfoPrintQueue", [])

    .constant("PrintixPrintQueueInfoConstants", {
      SHOW: "print_queue_info_show",
      HIDE: "print_queue_info_hide"
    })

    .constant("PrintixPrintQueueInfoSelectors", {
      MODAL_ID: "infoPrintQueueModal",
      CONFIRM_BUTTON_CSS_CLASS: "confirm-button"
    })


    .controller("InfoPrintQueueController", ["$rootScope", "$scope", "$location", "URLS", "PRINTER_STATUSES", "PrintixPrintQueueInfoConstants", "SUPPORTED_OS",
      "PrintixPrintQueueInfoSelectors", "$injector", "TenantListService", "PrintQueuePropertiesService",
      function($rootScope, $scope, $location, URLS, PRINTER_STATUSES, PrintixPrintQueueInfoConstants, SUPPORTED_OS,
        PrintixPrintQueueInfoSelectors, $injector, TenantListService, PrintQueuePropertiesService) {

        $scope.printQueue = null;
        $scope.tenantListService = TenantListService;
        $scope.printQueueInfoModalId = PrintixPrintQueueInfoSelectors.MODAL_ID;
        $scope.supportedOs = SUPPORTED_OS;

        $scope.clearPrintQueueInfo = function() {
          if ($scope.printQueue) {
            $scope.printQueue = null;
          }
        };

        var locationChangeListener = function(){};
        $scope.showPrintQueueInfo = function(printQueue) {
          if (printQueue) {
            $scope.printQueue = angular.copy(printQueue);

            PrintQueuePropertiesService.getQueueGroups($scope.printQueue)
              .then(result => {
                $scope.printQueue = result;
              })
              .catch(error => {
              });

            var printQueueModal = angular.element("#" + $scope.printQueueInfoModalId);
            printQueueModal.modal("show");
            locationChangeListener = $rootScope.$on('$locationChangeStart', function() {
              printQueueModal?.modal("hide");
            })
          } else {
            throw "$scope.showPrintQueueInfo: printQueue is missing";
          }
        };

        var SHOW_listener  = $rootScope.$on(PrintixPrintQueueInfoConstants.SHOW, function(name, printQueue) {
          $scope.showPrintQueueInfo(printQueue);
        });

        $scope.$on("$destroy", function() {
          SHOW_listener();
          locationChangeListener();
        });
      }
    ])

    .directive("infoPrintQueueObjectControl", ["$rootScope", "PrintixPrintQueueInfoSelectors", "PrintixPrintQueueInfoConstants",
      function($rootScope, PrintixPrintQueueInfoSelectors, PrintixPrintQueueInfoConstants) {
        return {
          link: function($scope, element, attrs) {
            element.on("hide.bs.modal", function() {
              $scope.clearPrintQueueInfo(angular.element(document.activeElement).hasClass(PrintixPrintQueueInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
            });
            var HIDE_listener = $rootScope.$on(PrintixPrintQueueInfoConstants.HIDE, function() {
              element.modal("hide");
            });

            $scope.$on("$destroy", function() {
              HIDE_listener();
            });
          }
        };
      }
    ]);
})();
